module.exports = __webpack_public_path__ + "static/img/avatar.2e222ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/avatar.png
// module id = HG8h
// module chunks = 52